/**
 * ADR-102: аналитика и отчётность инстанса — контракт пред-агрегированных
 * суточных роллапов.
 *
 * Единица роллапа — **сутки в UTC**. Хранилище держит **сырые счётчики**
 * (`measures` + `costByCurrency`); дериваты (`cache_hit_rate`, `output_tps`,
 * итоги по валютам) считает сервис на чтении. Роллапы агрегированы: текстов
 * сообщений, содержимого промптов, ключей и PII в значениях нет.
 */
/** Семейства роллапов (ADR-102 §2). */
export const ANALYTICS_FAMILIES = ['usage', 'activity', 'decision', 'prompt'];
/**
 * Оси измерений роллапа. Короткие ключи `dimensions`; `day` — отдельное поле
 * бакета (`AnalyticsRollupBucket.day`), но участвует в фильтрах и группировке.
 */
export const ANALYTICS_DIMENSIONS = ['day', 'user', 'project', 'model', 'agent', 'provider'];
/**
 * Известные меры по семействам. Имена — snake_case (как в `sessions/stats.ts`:
 * `input_tokens`/`output_tokens`/`cost_usd`/…). Список — подсказка/валидация
 * уровня домена: хранилище неизвестные числовые меры не отбрасывает.
 */
export const ANALYTICS_MEASURES_BY_FAMILY = {
    usage: [
        'input_tokens',
        'output_tokens',
        'cache_read_tokens',
        'cache_write_tokens',
        'reasoning_tokens',
        'requests',
        'messages',
        'duration_ms',
    ],
    activity: [
        'sessions_created',
        'sessions_archived',
        'messages_user',
        'messages_assistant',
        'messages_tool',
        'tool_calls',
        'errors',
        'aborts',
        'turns',
    ],
    // Персистентная замена in-memory снимка `decisionMetrics` (ADR-084); модель — ось, `by_model` не дублируется.
    decision: ['calls', 'handled', 'fallback', 'escalated', 'attempts', 'rejected'],
    // `prompt` — производные от `usage` (`cache_hit_rate`, доля reasoning, output tps): отдельной записи не требует.
    prompt: [],
};
/**
 * Дериваты, которые сервис считает **на чтении** из сырых счётчиков (не
 * персистятся, ADR-102 §2). В строке отчёта лежат рядом с сырыми мерами; при
 * экспорте выносятся отдельными колонками после сырых мер.
 */
export const ANALYTICS_DERIVED_MEASURES = [
    'total_tokens',
    'cache_hit_rate',
    'reasoning_ratio',
    'output_tps',
];
/** Формат выгрузки отчёта (server-side, только данные — ADR-102 §6). */
export const ANALYTICS_EXPORT_FORMATS = ['csv', 'json'];
